import { withTheme as withTheme$1, useTheme as useTheme$1 } from 'styled-components';
export { ThemeProvider, createGlobalStyle, css, keyframes, default as styled } from 'styled-components';

const withTheme = withTheme$1;
const useTheme = useTheme$1;

export { useTheme, withTheme };
